import { format } from "date-fns";

import { getTitle } from "../admin/productHelper";

import { GOOGLE_DRIVE_CDN, PRODUCT_NO_IMG } from "../../constants/constants";

const DATA = {
    generate: true,
    message: '',
    payment_url: ''
};

const DATA2 = {
    generate: false,
    message: 'No se pudo obtener su enlace de pago',
    payment_url: ''
};

export const getCategoryURL = (category) => {
    return category.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
};

// da formato a variantes de producto
/* esto con la finalidad de mostrar en tarjeta
   de tienda aquella variante más destacada */
export const formatMainVariant = (title, prod_variants) => {
    return prod_variants.length > 1 ?
        multipleVariants(title, prod_variants)
    : singleVariant(title, prod_variants);
};

const multipleVariants = (title, prod_variants) => {
    // variante con promoción
    const VariantInPromo = prod_variants.find(
        e => e.item_promotion && e.item_promotion.promo !== ''
    );
    // precios de variantes
    const prices = prod_variants.map(e => e.price);
    const min_price = Math.min(...prices);
    // variante con precio más bajo
    const CheaperVariant = prod_variants.find(e => e.price === min_price);
    return {
        unique: false, // múltiples variantes
        min_price, // variante más económica
        max_price: Math.max(...prices), // variante más costosa
        /* mostrar en tarjeta variante que tiene promoción activa
           caso contrario, mostrar la de menor precio */
        MainVariant: VariantInPromo ?
            mainVariantData(title, VariantInPromo)
        :
            mainVariantData(title, CheaperVariant)
    };
};

const singleVariant = (title, prod_variants) => {
    const { price } = prod_variants[0];
    return {
        unique: true,
        min_price: price,
        max_price: price,
        MainVariant: mainVariantData(title, prod_variants[0])
    };
};

// incluye nombre completo de producto e imagen principal
const mainVariantData = (title, variant) => {
    const { variant_title, images, ...e } = variant;
    const full_title = getTitle(title, variant_title);
    const img = formatMainImage(images);
    return { ...e, full_title, img };
};

export const formatMainImage = (images) => {
    return images.length > 0 ?
        {
            id: `${GOOGLE_DRIVE_CDN}${images[0].id}`,
            alt: images[0].alt ? images[0].alt : 'producto-nefropolis'
        }
    :
        {
            id: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`,
            alt: 'producto-nefropolis'
        };
};

export const mainVariantOnly = (title, prod_variants) => {
    // variante con promoción
    const VariantInPromo = prod_variants.find(
        e => e.item_promotion && e.item_promotion.promo !== ''
    );
    // variante con precio más bajo
    const min_price = Math.min(...prod_variants.map(e => e.price));
    const CheaperVariant = prod_variants.find(e => e.price === min_price);
    
    return VariantInPromo ?
        mainVariantData(title, VariantInPromo)
    :
        mainVariantData(title, CheaperVariant)
};

// reseñas de producto
export const formatProductReviews = (reviewSummary = {}) => {
    if (Array.isArray(reviewSummary)) {
        const review_count = reviewSummary.length;
        const total = reviewSummary.reduce(
            (sum, review) => sum + Number(review.rating || 0),
            0
        );
        const review_prom = review_count > 0 ?
            Math.round(total / review_count)
        :
            0;

        return { review_prom, review_count };
    }

    return {
        review_prom: Math.round(Number(reviewSummary.average || 0)),
        review_count: Number(reviewSummary.count || 0)
    };
};

export const formatPromotionProducts = (shopProducts) => {
    let products = [];
    for (const {
        _id: prod_id, title, url, prod_variants, review_summary
    } of shopProducts) {
        for (const {
            _id: prod_var_id, variant_title, price, barcode, item_promotion, images
        } of prod_variants) {
            if (item_promotion && item_promotion.promo !== '')
                products = [...products, {
                    prod_id, prod_var_id, title, url, review_summary,
                    variant_title, price, barcode, item_promotion,
                    images
                }];
        };
    };
    return products;
};

const getCouponData = (coupon) => {
    if (!coupon)
        return { name: '', text: '' };

    const { name, _class, discount: { type, _value } } = coupon;
    return {
        name, text: _class === 'free_shipping' ?
            'Se otorgó envío gratis'
        :
            type === 'percentage' ? `${_value}% de descuento` : `$${_value} de descuento`
    };
};

const formatBilling = (req_invoice, data) => {
    if (!req_invoice)
        return {
            req_invoice, data: {
                business_name: '', rfc: '', cif: '', tax_system: '',
                cfdi: '', b_tel: '', b_address: '', b_postalcode: '',
                b_colony: '', b_city: '', b_state: ''
            }
        };
    else {
        const {
            // business_name, rfc, cif, tax_system, cfdi,
            tel, address, postalcode, colony, city, state,
            ...order_billing
        } = data;
        return {
            req_invoice, data: {
                ...order_billing,
                b_tel: tel,
                b_address: address,
                b_postalcode: postalcode,
                b_colony: colony,
                b_city: city,
                b_state: state
            }
        };
    }
};

const getPaymentData = (method, status, external_resource_url, payment_url) => {
    switch(method) {
        case 'MercadoPago':
            return {
                method, status,
                text: 'Tarjeta de crédito, débito y Efectivo',
                mercargopago: {
                    external_resource_url,
                    generate: false,
                    message: 'Continúe con su pago',
                    payment_url
                },
                paypal: DATA,
                openpay: DATA
            };
        case 'PayPal':
            return {
                method, status,
                text: '',
                paypal: {
                    generate: false,
                    message: 'Continúe con su pago',
                    payment_url
                },
                mercadopago: { ...DATA, external_resource_url },
                openpay: DATA
            };
        case 'OpenPay':
            return {
                method, status,
                text: 'Tarjeta de crédito / débito',
                openpay: {
                    generate: false,
                    message: 'Continúe con su pago',
                    payment_url
                },
                mercadopago: { ...DATA, external_resource_url },
                paypal: DATA
            };
        default:
            return {
                method, status, text: 'Método de pago desconocido',
                mercadopago: { ...DATA2, external_resource_url },
                paypal: DATA2,
                openpay: DATA2
            };
    };
};

const formatProducts = (products) => {
    return products.map(({ title, variant_title, price, quantity, discount, images }) => {
        const product_price = discount ? discount.item_total : price;
        const price_text = `Total => $${product_price} `;
        const qty_text = `(${quantity} producto${quantity > 1 ? 's' : ''})`;
        const img = images.length > 0 ?
            {
                id: `${GOOGLE_DRIVE_CDN}${images[0].id}`,
                alt: images[0].alt ? images[0].alt : 'producto-nefropolis'
            }
        :
            {
                id: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`,
                alt: 'producto-nefropolis'
            };
        return {
            title: getTitle(title, variant_title),
            price_text, qty_text, img
        };
    });
};

// formatear datos de pedido recién generado (fast checkout)
export const formatCheckoutOrder = (model, _id, order_num, method, payment_url) => {
    const {
        summary, products, address, shipping, coupon,
        billing: { req_invoice, data }
    } = model;
    return {
        _id, order_num, summary, address, shipping,
        order_date: `${format(new Date(), 'dd/MM/yyyy')}`,
        coupon: getCouponData(coupon),
        billing: formatBilling(req_invoice, data),
        payment: getPaymentData(method, 'registered', '', payment_url),
        products: formatProducts(products)
    };
};
